const consolidatedMonthlyLineItemResource = (() => {
    const _default_config = {
        width: {
            chart1: 0
        }
    };
    const init = (default_config, resource, resource_config) => {
        Object.assign(_default_config, default_config);
        Object.assign(_default_config, resource_config);
        _default_config.resource = resource;
        _default_config.last_selected_account_number_option = _default_config._default_option;
        _default_config.old_data = _default_config.data;
        _default_config.headerMonths = _default_config.old_data.months;
        _default_config.maped_data = new Map();
        _default_config.maped_data[_default_config._default_option] = updateData(_default_config.data);
        for (let i = 0; i < _default_config.account_level.length; ++i) _default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = updateData(_default_config.account_level[i]);
        appendHTML();
        templateEvents.updatedOnWindowResize(loadChart);
    };

    /**
     * appendHTML : attaching html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const appendHTML = () => {
        extractHeaders();
        extractAccountNumber();
        appendTableHeader();
        populateConsolidatedData();
    };

    /**
     * updateData : update data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param data object
     */

    const updateData = (data) => {
        const resp = [];
        for (let i = 0; i < data['transactions'].length; ++i) {
            const obj = {
                "transaction": data['transactions'][i]['transaction_type'].replace(data['transactions'][i]['transaction_type'][0], data['transactions'][i]['transaction_type'][0].toUpperCase()),
                "category": data['transactions'][i]['category']
            };
            for (let j = 0; j < data['transactions'][i]['months'].length; ++j) obj[data['transactions'][i]['months'][j]['month']] = data['transactions'][i]['months'][j]['value'];
            obj['average'] = data['transactions'][i]['average'];
            resp.push(obj);
        }
        return resp.sort(function (a, b) {
            return a.average - b.average; //DESC
            // return b.average - a.average; //ASC
          });
    };

    /**
     * appendTableHeader : updating table headers for appending
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     */

    function appendTableHeader() {
        _default_config.table_divs = _default_config.table_divs[_default_config.resource];
        _default_config.table_divs[2].columns = initScript.removeUnexpectedElements(_default_config.headers, ["category", "transaction"]);
    }

    /**
     * populateConsolidatedData : show consolidated data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     */

    function populateConsolidatedData() {
        _default_config.data = mergeSort(_default_config.maped_data[_default_config._default_option], "transaction");
        templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);
        filterData();
        _default_config.width.chart1 = initScript.getHTMLElementByDelimiter("monthlyLineItemDebitChart", "#").width();
        loadChart();
    }

    /**
     * extractHeaders : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function extractHeaders() {
        let data = _default_config.data;
        const months = [];
        for (let i = 0; i < data['months'].length; ++i) {
            months.push(data['months'][i]);
            _default_config.columns[data['months'][i]] = _default_config["_" + _default_config.resource]._default_option_config;
        }
        _default_config.headers = ['transaction', 'category'].concat(months).concat("average");
    }

    /**
     * loadChart : loading chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function loadChart() {
        clearElements();
        if(false){
            const config = _default_config.charts[_default_config.resource].config;
            const dd = initScript.getHTMLElementByDelimiter("monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
            config.width = _default_config.width.chart1 * 0.92;
            config.margin = _default_config.width.chart1 * 0.08;
            config.data[0].values = getChartData();
            config.tooltip.left = (window.innerWidth - initScript.getHTMLElementByDelimiter("hideShowSection1").width()) / 2;
            config.tooltip.top = dd + 16 - 10 - 25;
            config.tooltip.diff_class = "graph";
            config.tooltip.diff = true;

            const config1 = _default_config.charts[_default_config.resource].config1;
            config1.width = _default_config.width.chart1 * 0.92;
            config1.margin = _default_config.width.chart1 * 0.08;
            config1.tooltip.left = config.tooltip.left + 10 + initScript.getHTMLElementByDelimiter("hideShowSection1 .row .col-6").width() + 30;
            config1.tooltip.top = config.tooltip.top;
            config1.tooltip.diff_class = "graph";
            config1.tooltip.diff = true;
            config1.data[0].values = getChartData("debit");
            
            charts.line.init(config);
            charts.line.init(config1);
        }
        analyserV2.resolvePromise();
    }

    /**
     * extractAccountNumber : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function extractAccountNumber() {
        _default_config.account_number = templateEvents.maskingUtility(initScript.extractMapData(_default_config.account_level, "account_number"));
    }

    /**
     * initializeData : initializing data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function initializeData() {
        const data = [];
        for (let i = 0; i < _default_config.headerMonths.length; ++i)
            data.push({ "price": 0, "date": templateEvents.dateToYearMonthFormat(_default_config.headerMonths[i]) });
        return data;
    }

    /**
     * getChartData : returning chart data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function getChartData(category = "credit") {
        const data = _default_config.maped_data[_default_config.last_selected_account_number_option], resp = initializeData();
        for (let i = 0; i < data.length; ++i) {
            if (data[i].transaction.toLowerCase() !== category) continue;
            for (let j = Math.max(0, _default_config.headerMonths.length - 12); j < _default_config.headerMonths.length; ++j)
                resp[j].price += data[i][_default_config.headerMonths[j]];
        }
        return resp;
    }

	/**
     * filterData : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function filterData() {
        let filter_options = _default_config.filter || {};
        filter_options = Object.keys(filter_options);
        for (let i = 0; i < filter_options.length; ++i) {
            const html_config = [];
            let options = _default_config[filter_options[i]];
            if (options.length > 1) options = [_default_config._default_option].concat(options);
            for (let j = 0; j < options.length; ++j) {
                html_config.push({
					"html":(options[j] === _default_config._default_option) ? (initScript.getObjectValue(_default_config, "body.config." + _default_config.resource + ".filter." + filter_options[i] + ".default_option") || options[j]) : options[j],
                    "config": { "value": options[j] }
                });
            }
            initScript.getHTMLElementByDelimiter(initScript.keyToCamelCaseString(filter_options[i] + "_" + _default_config.resource + "_filter")).html(initScript.getCommonHTML(html_config, "option"));
        }
    }

    /**
     * clearElements : clearing html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function clearElements() {
        initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter("monthlyLineItemDebitChart", "#"), "");
        initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter("monthlyLineItemCreditChart", "#"), "");
    }

    /**
     * refreshHTML : showing consolidated html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function refreshHTML() {
        _default_config.data = _default_config.maped_data[_default_config.last_selected_account_number_option];
        _default_config.data = sortByAverage(_default_config.data)

        document.querySelector(".monthlyLineItemDataHead").innerHTML = ""
        if(_default_config.last_selected_account_number_option !== "All"){
            var headerMonths = _default_config.account_level.filter(e => templateEvents.stringMasking(e.account_number) == _default_config.last_selected_account_number_option)[0]
            _default_config.headerMonths = headerMonths["months"];
        }
        else{
            _default_config.headerMonths = _default_config.old_data.months;
        }
        const months = [];
        for (let i = 0; i < _default_config.headerMonths.length; ++i) {
            months.push(_default_config.headerMonths[i]);
            _default_config.columns[_default_config.headerMonths[i]] = _default_config["_" + _default_config.resource]._default_option_config;
        }
        _default_config.headers = ['transaction', 'category'].concat(months).concat("average");
        _default_config.table_divs[2].columns = initScript.removeUnexpectedElements(_default_config.headers, ["category", "transaction"]); 
        templateUtil.appendTabelHeaders(_default_config);

        templateUtil.appendTabelRows(_default_config);
        loadChart();
    }

    function compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }
      
          const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
          const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];
      
          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return (
            (order === 'desc') ? (comparison * -1) : comparison
          );
        };
      }

    function sortByAverage(data){
        var sortOrder1 = data.sort(compareValues("transaction", "asc"));
        var sortOrder2 = sortOrder1.sort(function (a, b) {
            if(a.transaction === b.transaction)
            return b.average - a.average; //DESC
            else
            return 0
          });
          return sortOrder2;
    }

    function getMonthlyLineItemSelectedValue(event) {
        const selected_val = event.target.value.trim();
        if (_default_config.last_selected_account_number_option === selected_val) return;
        _default_config.last_selected_account_number_option = selected_val;
        refreshHTML();
    }

    return {
        init,
        getMonthlyLineItemSelectedValue,
    };
})();
